export default __webpack_public_path__ + "static/media/Claire_Cetti_AHV_In_Moms_We_Trust.ef3913eb.jpg";